import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class TextSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: false,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: true,
            fade: false,
            cellSelector: '.text-image-section__slide',
            imagesLoaded: true,
            cellAlign: 'left', 
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.text-image-section__slide');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 1) {
            this._createSlider();
        }
    }

    _createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}

export default TextSlider;